import { IRiskWidgetProps } from "./RiskWidget.tsx";
import { DashboardRiskOverview } from "./RiskWidget.types.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { usePlanContext } from "../../auth/planProvider/PlanProvider.tsx";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useRiskWidget(props: IRiskWidgetProps) {
    const userContext = useUserContext();

    const hasProcessingActivityAccess = userContext.permissions.processingActivityPermissions.read && userContext.permissions.riskPermissions.read;
    const hasSystemAccess = userContext.permissions.systemPermissions.read && userContext.permissions.riskPermissions.read;

    const defaultSystemsChosen = hasProcessingActivityAccess ? false : hasSystemAccess;

    const localStorageKey = "dashboard-risk-systems-chosen";
    const storageValue = localStorage.getItem(localStorageKey);
    const [systemsChosen, setSystemsChosen] = useStateLocalStorage(localStorageKey, props.isSystemChosen ?? defaultSystemsChosen);

    if (
        (storageValue === "false" && !hasProcessingActivityAccess) ||
        (!defaultSystemsChosen && !hasProcessingActivityAccess) ||
        (defaultSystemsChosen && !hasSystemAccess) ||
        (storageValue === "true" && !hasSystemAccess)
    ) {
        localStorage.removeItem(localStorageKey);
    }

    const isEnabled =
        (hasProcessingActivityAccess || hasSystemAccess) && !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.Risk);

    const url = `/ProcessingActivityRiskOverview/dashboard?systemsChosen=${systemsChosen}&onlyUserSpecific=${props.onlyUserSpecific}&forGroupCompany=${props.selectedGroupCompany}`;
    const { isLoading, data } = useDotLegalQuery<DashboardRiskOverview>(url, {
        enabled: isEnabled,
    });
    const onPaOrSystemChange = () => {
        setSystemsChosen(!systemsChosen);
    };

    return {
        systemsChosen,
        onPaOrSystemChange,
        isLoading: isLoading,
        data,
        isEnabled,
        systemsOptionEnabled: hasSystemAccess,
        processingActivityOptionEnabled: hasProcessingActivityAccess,
    };
}
